"use client";

import { c as _c } from "react/compiler-runtime";
import { AggregatedActivity, AggregatedActivityMemes } from "@/entities/IAggregatedActivity";
import { ApiIdentity } from "@/generated/models/ApiIdentity";
import { numberWithCommas } from "@/helpers/Helpers";
import { commonApiFetch } from "@/services/api/common-api";
import { Fragment, useEffect, useState } from "react";
import { Accordion, Col, Container, Row, Table } from "react-bootstrap";
import { getStatsPath } from "./userPageStats.helpers";
import styles from "./UserPageStats.module.scss";
import { UserPageStatsTableHead, UserPageStatsTableHr } from "./UserPageStatsTableShared";
function printEthValue(value: number | undefined) {
  if (value === undefined) {
    return "-";
  }
  return numberWithCommas(Math.round(value * 100) / 100);
}
export default function UserPageStatsActivityOverview(t0) {
  const $ = _c(17);
  const {
    profile,
    activeAddress
  } = t0;
  const [activity, setActivity] = useState();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [activityMemes, setActivityMemes] = useState(t1);
  let t2;
  let t3;
  if ($[1] !== activeAddress || $[2] !== profile) {
    t2 = () => {
      const controller = new AbortController();
      const url = `aggregated-activity/${getStatsPath(profile, activeAddress)}`;
      commonApiFetch({
        endpoint: url,
        signal: controller.signal
      }).then(setActivity).catch(() => {
        setActivity(undefined);
      });
      return () => controller.abort();
    };
    t3 = [activeAddress, profile];
    $[1] = activeAddress;
    $[2] = profile;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
  let t4;
  let t5;
  if ($[5] !== activeAddress || $[6] !== profile) {
    t4 = () => {
      const controller_0 = new AbortController();
      const url_0 = `aggregated-activity/${getStatsPath(profile, activeAddress)}/memes`;
      commonApiFetch({
        endpoint: url_0,
        signal: controller_0.signal
      }).then(response => {
        setActivityMemes(response);
      }).catch(() => {
        setActivityMemes([]);
      });
      return () => controller_0.abort();
    };
    t5 = [activeAddress, profile];
    $[5] = activeAddress;
    $[6] = profile;
    $[7] = t4;
    $[8] = t5;
  } else {
    t4 = $[7];
    t5 = $[8];
  }
  useEffect(t4, t5);
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="tw-flex pt-2 pb-2"><h3 className="tw-mb-0 tw-text-lg tw-font-semibold tw-text-iron-100">Activity Overview</h3></div>;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== activity) {
    t7 = <div className="pt-2 pb-2"><UserPageStatsActivityOverviewTotals activity={activity} /></div>;
    $[10] = activity;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== activityMemes) {
    t8 = <div className="pt-2 pb-2"><UserPageStatsActivityOverviewMemes activity={activityMemes} /></div>;
    $[12] = activityMemes;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t7 || $[15] !== t8) {
    t9 = <div className="pt-2 pb-2">{t6}{t7}{t8}</div>;
    $[14] = t7;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  return t9;
}
function UserPageStatsActivityOverviewTotals(t0) {
  const $ = _c(285);
  const {
    activity
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Accordion.Button className={styles.collectedAccordionButton}><b>Overview</b></Accordion.Button>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <UserPageStatsTableHead />;
    t3 = <UserPageStatsTableHr span={6} />;
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <td className="!tw-text-[#93939f]"><b>Airdrops</b></td>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = activity?.airdrops;
  let t6;
  if ($[4] !== t5) {
    t6 = numberWithCommas(t5);
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== t6) {
    t7 = <td className="tw-text-right !tw-text-[#fff]">{t6}</td>;
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  const t8 = activity?.airdrops_memes;
  let t9;
  if ($[8] !== t8) {
    t9 = numberWithCommas(t8);
    $[8] = t8;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== t9) {
    t10 = <td className="tw-text-right !tw-text-[#fff]">{t9}</td>;
    $[10] = t9;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  const t11 = activity?.airdrops_nextgen;
  let t12;
  if ($[12] !== t11) {
    t12 = numberWithCommas(t11);
    $[12] = t11;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  let t13;
  if ($[14] !== t12) {
    t13 = <td className="tw-text-right !tw-text-[#fff]">{t12}</td>;
    $[14] = t12;
    $[15] = t13;
  } else {
    t13 = $[15];
  }
  const t14 = activity?.airdrops_gradients;
  let t15;
  if ($[16] !== t14) {
    t15 = numberWithCommas(t14);
    $[16] = t14;
    $[17] = t15;
  } else {
    t15 = $[17];
  }
  let t16;
  if ($[18] !== t15) {
    t16 = <td className="tw-text-right !tw-text-[#fff]">{t15}</td>;
    $[18] = t15;
    $[19] = t16;
  } else {
    t16 = $[19];
  }
  const t17 = activity?.airdrops_memelab;
  let t18;
  if ($[20] !== t17) {
    t18 = numberWithCommas(t17);
    $[20] = t17;
    $[21] = t18;
  } else {
    t18 = $[21];
  }
  let t19;
  if ($[22] !== t18) {
    t19 = <td className="tw-text-right !tw-text-[#fff]">{t18}</td>;
    $[22] = t18;
    $[23] = t19;
  } else {
    t19 = $[23];
  }
  let t20;
  if ($[24] !== t10 || $[25] !== t13 || $[26] !== t16 || $[27] !== t19 || $[28] !== t7) {
    t20 = <tr>{t4}{t7}{t10}{t13}{t16}{t19}</tr>;
    $[24] = t10;
    $[25] = t13;
    $[26] = t16;
    $[27] = t19;
    $[28] = t7;
    $[29] = t20;
  } else {
    t20 = $[29];
  }
  let t21;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <td className="!tw-text-[#93939f]"><b>Transfers In</b></td>;
    $[30] = t21;
  } else {
    t21 = $[30];
  }
  const t22 = activity?.transfers_in;
  let t23;
  if ($[31] !== t22) {
    t23 = numberWithCommas(t22);
    $[31] = t22;
    $[32] = t23;
  } else {
    t23 = $[32];
  }
  let t24;
  if ($[33] !== t23) {
    t24 = <td className="tw-text-right !tw-text-[#fff]">{t23}</td>;
    $[33] = t23;
    $[34] = t24;
  } else {
    t24 = $[34];
  }
  const t25 = activity?.transfers_in_memes;
  let t26;
  if ($[35] !== t25) {
    t26 = numberWithCommas(t25);
    $[35] = t25;
    $[36] = t26;
  } else {
    t26 = $[36];
  }
  let t27;
  if ($[37] !== t26) {
    t27 = <td className="tw-text-right !tw-text-[#fff]">{t26}</td>;
    $[37] = t26;
    $[38] = t27;
  } else {
    t27 = $[38];
  }
  const t28 = activity?.transfers_in_nextgen;
  let t29;
  if ($[39] !== t28) {
    t29 = numberWithCommas(t28);
    $[39] = t28;
    $[40] = t29;
  } else {
    t29 = $[40];
  }
  let t30;
  if ($[41] !== t29) {
    t30 = <td className="tw-text-right !tw-text-[#fff]">{t29}</td>;
    $[41] = t29;
    $[42] = t30;
  } else {
    t30 = $[42];
  }
  const t31 = activity?.transfers_in_gradients;
  let t32;
  if ($[43] !== t31) {
    t32 = numberWithCommas(t31);
    $[43] = t31;
    $[44] = t32;
  } else {
    t32 = $[44];
  }
  let t33;
  if ($[45] !== t32) {
    t33 = <td className="tw-text-right !tw-text-[#fff]">{t32}</td>;
    $[45] = t32;
    $[46] = t33;
  } else {
    t33 = $[46];
  }
  const t34 = activity?.transfers_in_memelab;
  let t35;
  if ($[47] !== t34) {
    t35 = numberWithCommas(t34);
    $[47] = t34;
    $[48] = t35;
  } else {
    t35 = $[48];
  }
  let t36;
  if ($[49] !== t35) {
    t36 = <td className="tw-text-right !tw-text-[#fff]">{t35}</td>;
    $[49] = t35;
    $[50] = t36;
  } else {
    t36 = $[50];
  }
  let t37;
  if ($[51] !== t24 || $[52] !== t27 || $[53] !== t30 || $[54] !== t33 || $[55] !== t36) {
    t37 = <tr>{t21}{t24}{t27}{t30}{t33}{t36}</tr>;
    $[51] = t24;
    $[52] = t27;
    $[53] = t30;
    $[54] = t33;
    $[55] = t36;
    $[56] = t37;
  } else {
    t37 = $[56];
  }
  let t38;
  if ($[57] === Symbol.for("react.memo_cache_sentinel")) {
    t38 = <td className="!tw-text-[#93939f]"><b>Mints</b></td>;
    $[57] = t38;
  } else {
    t38 = $[57];
  }
  const t39 = activity?.primary_purchases_count;
  let t40;
  if ($[58] !== t39) {
    t40 = numberWithCommas(t39);
    $[58] = t39;
    $[59] = t40;
  } else {
    t40 = $[59];
  }
  let t41;
  if ($[60] !== t40) {
    t41 = <td className="tw-text-right !tw-text-[#fff]">{t40}</td>;
    $[60] = t40;
    $[61] = t41;
  } else {
    t41 = $[61];
  }
  const t42 = activity?.primary_purchases_count_memes;
  let t43;
  if ($[62] !== t42) {
    t43 = numberWithCommas(t42);
    $[62] = t42;
    $[63] = t43;
  } else {
    t43 = $[63];
  }
  let t44;
  if ($[64] !== t43) {
    t44 = <td className="tw-text-right !tw-text-[#fff]">{t43}</td>;
    $[64] = t43;
    $[65] = t44;
  } else {
    t44 = $[65];
  }
  const t45 = activity?.primary_purchases_count_nextgen;
  let t46;
  if ($[66] !== t45) {
    t46 = numberWithCommas(t45);
    $[66] = t45;
    $[67] = t46;
  } else {
    t46 = $[67];
  }
  let t47;
  if ($[68] !== t46) {
    t47 = <td className="tw-text-right !tw-text-[#fff]">{t46}</td>;
    $[68] = t46;
    $[69] = t47;
  } else {
    t47 = $[69];
  }
  const t48 = activity?.primary_purchases_count_gradients;
  let t49;
  if ($[70] !== t48) {
    t49 = numberWithCommas(t48);
    $[70] = t48;
    $[71] = t49;
  } else {
    t49 = $[71];
  }
  let t50;
  if ($[72] !== t49) {
    t50 = <td className="tw-text-right !tw-text-[#fff]">{t49}</td>;
    $[72] = t49;
    $[73] = t50;
  } else {
    t50 = $[73];
  }
  const t51 = activity?.primary_purchases_count_memelab;
  let t52;
  if ($[74] !== t51) {
    t52 = numberWithCommas(t51);
    $[74] = t51;
    $[75] = t52;
  } else {
    t52 = $[75];
  }
  let t53;
  if ($[76] !== t52) {
    t53 = <td className="tw-text-right !tw-text-[#fff]">{t52}</td>;
    $[76] = t52;
    $[77] = t53;
  } else {
    t53 = $[77];
  }
  let t54;
  if ($[78] !== t41 || $[79] !== t44 || $[80] !== t47 || $[81] !== t50 || $[82] !== t53) {
    t54 = <tr>{t38}{t41}{t44}{t47}{t50}{t53}</tr>;
    $[78] = t41;
    $[79] = t44;
    $[80] = t47;
    $[81] = t50;
    $[82] = t53;
    $[83] = t54;
  } else {
    t54 = $[83];
  }
  let t55;
  if ($[84] === Symbol.for("react.memo_cache_sentinel")) {
    t55 = <td className="!tw-text-[#93939f]"><b>Mints (ETH)</b></td>;
    $[84] = t55;
  } else {
    t55 = $[84];
  }
  const t56 = activity?.primary_purchases_value;
  let t57;
  if ($[85] !== t56) {
    t57 = printEthValue(t56);
    $[85] = t56;
    $[86] = t57;
  } else {
    t57 = $[86];
  }
  let t58;
  if ($[87] !== t57) {
    t58 = <td className="tw-text-right !tw-text-[#fff]">{t57}</td>;
    $[87] = t57;
    $[88] = t58;
  } else {
    t58 = $[88];
  }
  const t59 = activity?.primary_purchases_value_memes;
  let t60;
  if ($[89] !== t59) {
    t60 = printEthValue(t59);
    $[89] = t59;
    $[90] = t60;
  } else {
    t60 = $[90];
  }
  let t61;
  if ($[91] !== t60) {
    t61 = <td className="tw-text-right !tw-text-[#fff]">{t60}</td>;
    $[91] = t60;
    $[92] = t61;
  } else {
    t61 = $[92];
  }
  const t62 = activity?.primary_purchases_value_nextgen;
  let t63;
  if ($[93] !== t62) {
    t63 = printEthValue(t62);
    $[93] = t62;
    $[94] = t63;
  } else {
    t63 = $[94];
  }
  let t64;
  if ($[95] !== t63) {
    t64 = <td className="tw-text-right !tw-text-[#fff]">{t63}</td>;
    $[95] = t63;
    $[96] = t64;
  } else {
    t64 = $[96];
  }
  const t65 = activity?.primary_purchases_value_gradients;
  let t66;
  if ($[97] !== t65) {
    t66 = printEthValue(t65);
    $[97] = t65;
    $[98] = t66;
  } else {
    t66 = $[98];
  }
  let t67;
  if ($[99] !== t66) {
    t67 = <td className="tw-text-right !tw-text-[#fff]">{t66}</td>;
    $[99] = t66;
    $[100] = t67;
  } else {
    t67 = $[100];
  }
  const t68 = activity?.primary_purchases_value_memelab;
  let t69;
  if ($[101] !== t68) {
    t69 = printEthValue(t68);
    $[101] = t68;
    $[102] = t69;
  } else {
    t69 = $[102];
  }
  let t70;
  if ($[103] !== t69) {
    t70 = <td className="tw-text-right !tw-text-[#fff]">{t69}</td>;
    $[103] = t69;
    $[104] = t70;
  } else {
    t70 = $[104];
  }
  let t71;
  if ($[105] !== t58 || $[106] !== t61 || $[107] !== t64 || $[108] !== t67 || $[109] !== t70) {
    t71 = <tr>{t55}{t58}{t61}{t64}{t67}{t70}</tr>;
    $[105] = t58;
    $[106] = t61;
    $[107] = t64;
    $[108] = t67;
    $[109] = t70;
    $[110] = t71;
  } else {
    t71 = $[110];
  }
  let t72;
  if ($[111] === Symbol.for("react.memo_cache_sentinel")) {
    t72 = <td className="!tw-text-[#93939f]"><b>Purchases</b></td>;
    $[111] = t72;
  } else {
    t72 = $[111];
  }
  const t73 = activity?.secondary_purchases_count;
  let t74;
  if ($[112] !== t73) {
    t74 = numberWithCommas(t73);
    $[112] = t73;
    $[113] = t74;
  } else {
    t74 = $[113];
  }
  let t75;
  if ($[114] !== t74) {
    t75 = <td className="tw-text-right !tw-text-[#fff]">{t74}</td>;
    $[114] = t74;
    $[115] = t75;
  } else {
    t75 = $[115];
  }
  const t76 = activity?.secondary_purchases_count_memes;
  let t77;
  if ($[116] !== t76) {
    t77 = numberWithCommas(t76);
    $[116] = t76;
    $[117] = t77;
  } else {
    t77 = $[117];
  }
  let t78;
  if ($[118] !== t77) {
    t78 = <td className="tw-text-right !tw-text-[#fff]">{t77}</td>;
    $[118] = t77;
    $[119] = t78;
  } else {
    t78 = $[119];
  }
  const t79 = activity?.secondary_purchases_count_nextgen;
  let t80;
  if ($[120] !== t79) {
    t80 = numberWithCommas(t79);
    $[120] = t79;
    $[121] = t80;
  } else {
    t80 = $[121];
  }
  let t81;
  if ($[122] !== t80) {
    t81 = <td className="tw-text-right !tw-text-[#fff]">{t80}</td>;
    $[122] = t80;
    $[123] = t81;
  } else {
    t81 = $[123];
  }
  const t82 = activity?.secondary_purchases_count_gradients;
  let t83;
  if ($[124] !== t82) {
    t83 = numberWithCommas(t82);
    $[124] = t82;
    $[125] = t83;
  } else {
    t83 = $[125];
  }
  let t84;
  if ($[126] !== t83) {
    t84 = <td className="tw-text-right !tw-text-[#fff]">{t83}</td>;
    $[126] = t83;
    $[127] = t84;
  } else {
    t84 = $[127];
  }
  const t85 = activity?.secondary_purchases_count_memelab;
  let t86;
  if ($[128] !== t85) {
    t86 = numberWithCommas(t85);
    $[128] = t85;
    $[129] = t86;
  } else {
    t86 = $[129];
  }
  let t87;
  if ($[130] !== t86) {
    t87 = <td className="tw-text-right !tw-text-[#fff]">{t86}</td>;
    $[130] = t86;
    $[131] = t87;
  } else {
    t87 = $[131];
  }
  let t88;
  if ($[132] !== t75 || $[133] !== t78 || $[134] !== t81 || $[135] !== t84 || $[136] !== t87) {
    t88 = <tr>{t72}{t75}{t78}{t81}{t84}{t87}</tr>;
    $[132] = t75;
    $[133] = t78;
    $[134] = t81;
    $[135] = t84;
    $[136] = t87;
    $[137] = t88;
  } else {
    t88 = $[137];
  }
  let t89;
  if ($[138] === Symbol.for("react.memo_cache_sentinel")) {
    t89 = <td className="!tw-text-[#93939f]"><b>Purchases (ETH)</b></td>;
    $[138] = t89;
  } else {
    t89 = $[138];
  }
  const t90 = activity?.secondary_purchases_value;
  let t91;
  if ($[139] !== t90) {
    t91 = printEthValue(t90);
    $[139] = t90;
    $[140] = t91;
  } else {
    t91 = $[140];
  }
  let t92;
  if ($[141] !== t91) {
    t92 = <td className="tw-text-right !tw-text-[#fff]">{t91}</td>;
    $[141] = t91;
    $[142] = t92;
  } else {
    t92 = $[142];
  }
  const t93 = activity?.secondary_purchases_value_memes;
  let t94;
  if ($[143] !== t93) {
    t94 = printEthValue(t93);
    $[143] = t93;
    $[144] = t94;
  } else {
    t94 = $[144];
  }
  let t95;
  if ($[145] !== t94) {
    t95 = <td className="tw-text-right !tw-text-[#fff]">{t94}</td>;
    $[145] = t94;
    $[146] = t95;
  } else {
    t95 = $[146];
  }
  const t96 = activity?.secondary_purchases_value_nextgen;
  let t97;
  if ($[147] !== t96) {
    t97 = printEthValue(t96);
    $[147] = t96;
    $[148] = t97;
  } else {
    t97 = $[148];
  }
  let t98;
  if ($[149] !== t97) {
    t98 = <td className="tw-text-right !tw-text-[#fff]">{t97}</td>;
    $[149] = t97;
    $[150] = t98;
  } else {
    t98 = $[150];
  }
  const t99 = activity?.secondary_purchases_value_gradients;
  let t100;
  if ($[151] !== t99) {
    t100 = printEthValue(t99);
    $[151] = t99;
    $[152] = t100;
  } else {
    t100 = $[152];
  }
  let t101;
  if ($[153] !== t100) {
    t101 = <td className="tw-text-right !tw-text-[#fff]">{t100}</td>;
    $[153] = t100;
    $[154] = t101;
  } else {
    t101 = $[154];
  }
  const t102 = activity?.secondary_purchases_value_memelab;
  let t103;
  if ($[155] !== t102) {
    t103 = printEthValue(t102);
    $[155] = t102;
    $[156] = t103;
  } else {
    t103 = $[156];
  }
  let t104;
  if ($[157] !== t103) {
    t104 = <td className="tw-text-right !tw-text-[#fff]">{t103}</td>;
    $[157] = t103;
    $[158] = t104;
  } else {
    t104 = $[158];
  }
  let t105;
  if ($[159] !== t101 || $[160] !== t104 || $[161] !== t92 || $[162] !== t95 || $[163] !== t98) {
    t105 = <tr>{t89}{t92}{t95}{t98}{t101}{t104}</tr>;
    $[159] = t101;
    $[160] = t104;
    $[161] = t92;
    $[162] = t95;
    $[163] = t98;
    $[164] = t105;
  } else {
    t105 = $[164];
  }
  let t106;
  if ($[165] === Symbol.for("react.memo_cache_sentinel")) {
    t106 = <UserPageStatsTableHr span={6} />;
    $[165] = t106;
  } else {
    t106 = $[165];
  }
  let t107;
  if ($[166] === Symbol.for("react.memo_cache_sentinel")) {
    t107 = <td className="!tw-text-[#93939f]"><b>Transfers Out</b></td>;
    $[166] = t107;
  } else {
    t107 = $[166];
  }
  const t108 = activity?.transfers_out;
  let t109;
  if ($[167] !== t108) {
    t109 = numberWithCommas(t108);
    $[167] = t108;
    $[168] = t109;
  } else {
    t109 = $[168];
  }
  let t110;
  if ($[169] !== t109) {
    t110 = <td className="tw-text-right !tw-text-[#fff]">{t109}</td>;
    $[169] = t109;
    $[170] = t110;
  } else {
    t110 = $[170];
  }
  const t111 = activity?.transfers_out_memes;
  let t112;
  if ($[171] !== t111) {
    t112 = numberWithCommas(t111);
    $[171] = t111;
    $[172] = t112;
  } else {
    t112 = $[172];
  }
  let t113;
  if ($[173] !== t112) {
    t113 = <td className="tw-text-right !tw-text-[#fff]">{t112}</td>;
    $[173] = t112;
    $[174] = t113;
  } else {
    t113 = $[174];
  }
  const t114 = activity?.transfers_out_nextgen;
  let t115;
  if ($[175] !== t114) {
    t115 = numberWithCommas(t114);
    $[175] = t114;
    $[176] = t115;
  } else {
    t115 = $[176];
  }
  let t116;
  if ($[177] !== t115) {
    t116 = <td className="tw-text-right !tw-text-[#fff]">{t115}</td>;
    $[177] = t115;
    $[178] = t116;
  } else {
    t116 = $[178];
  }
  const t117 = activity?.transfers_out_gradients;
  let t118;
  if ($[179] !== t117) {
    t118 = numberWithCommas(t117);
    $[179] = t117;
    $[180] = t118;
  } else {
    t118 = $[180];
  }
  let t119;
  if ($[181] !== t118) {
    t119 = <td className="tw-text-right !tw-text-[#fff]">{t118}</td>;
    $[181] = t118;
    $[182] = t119;
  } else {
    t119 = $[182];
  }
  const t120 = activity?.transfers_out_memelab;
  let t121;
  if ($[183] !== t120) {
    t121 = numberWithCommas(t120);
    $[183] = t120;
    $[184] = t121;
  } else {
    t121 = $[184];
  }
  let t122;
  if ($[185] !== t121) {
    t122 = <td className="tw-text-right !tw-text-[#fff]">{t121}</td>;
    $[185] = t121;
    $[186] = t122;
  } else {
    t122 = $[186];
  }
  let t123;
  if ($[187] !== t110 || $[188] !== t113 || $[189] !== t116 || $[190] !== t119 || $[191] !== t122) {
    t123 = <tr>{t107}{t110}{t113}{t116}{t119}{t122}</tr>;
    $[187] = t110;
    $[188] = t113;
    $[189] = t116;
    $[190] = t119;
    $[191] = t122;
    $[192] = t123;
  } else {
    t123 = $[192];
  }
  let t124;
  if ($[193] === Symbol.for("react.memo_cache_sentinel")) {
    t124 = <td className="!tw-text-[#93939f]"><b>Burns</b></td>;
    $[193] = t124;
  } else {
    t124 = $[193];
  }
  const t125 = activity?.burns;
  let t126;
  if ($[194] !== t125) {
    t126 = numberWithCommas(t125);
    $[194] = t125;
    $[195] = t126;
  } else {
    t126 = $[195];
  }
  let t127;
  if ($[196] !== t126) {
    t127 = <td className="tw-text-right !tw-text-[#fff]">{t126}</td>;
    $[196] = t126;
    $[197] = t127;
  } else {
    t127 = $[197];
  }
  const t128 = activity?.burns_memes;
  let t129;
  if ($[198] !== t128) {
    t129 = numberWithCommas(t128);
    $[198] = t128;
    $[199] = t129;
  } else {
    t129 = $[199];
  }
  let t130;
  if ($[200] !== t129) {
    t130 = <td className="tw-text-right !tw-text-[#fff]">{t129}</td>;
    $[200] = t129;
    $[201] = t130;
  } else {
    t130 = $[201];
  }
  const t131 = activity?.burns_nextgen;
  let t132;
  if ($[202] !== t131) {
    t132 = numberWithCommas(t131);
    $[202] = t131;
    $[203] = t132;
  } else {
    t132 = $[203];
  }
  let t133;
  if ($[204] !== t132) {
    t133 = <td className="tw-text-right !tw-text-[#fff]">{t132}</td>;
    $[204] = t132;
    $[205] = t133;
  } else {
    t133 = $[205];
  }
  const t134 = activity?.burns_gradients;
  let t135;
  if ($[206] !== t134) {
    t135 = numberWithCommas(t134);
    $[206] = t134;
    $[207] = t135;
  } else {
    t135 = $[207];
  }
  let t136;
  if ($[208] !== t135) {
    t136 = <td className="tw-text-right !tw-text-[#fff]">{t135}</td>;
    $[208] = t135;
    $[209] = t136;
  } else {
    t136 = $[209];
  }
  const t137 = activity?.burns_memelab;
  let t138;
  if ($[210] !== t137) {
    t138 = numberWithCommas(t137);
    $[210] = t137;
    $[211] = t138;
  } else {
    t138 = $[211];
  }
  let t139;
  if ($[212] !== t138) {
    t139 = <td className="tw-text-right !tw-text-[#fff]">{t138}</td>;
    $[212] = t138;
    $[213] = t139;
  } else {
    t139 = $[213];
  }
  let t140;
  if ($[214] !== t127 || $[215] !== t130 || $[216] !== t133 || $[217] !== t136 || $[218] !== t139) {
    t140 = <tr>{t124}{t127}{t130}{t133}{t136}{t139}</tr>;
    $[214] = t127;
    $[215] = t130;
    $[216] = t133;
    $[217] = t136;
    $[218] = t139;
    $[219] = t140;
  } else {
    t140 = $[219];
  }
  let t141;
  if ($[220] === Symbol.for("react.memo_cache_sentinel")) {
    t141 = <td className="!tw-text-[#93939f]"><b>Sales</b></td>;
    $[220] = t141;
  } else {
    t141 = $[220];
  }
  const t142 = activity?.sales_count;
  let t143;
  if ($[221] !== t142) {
    t143 = numberWithCommas(t142);
    $[221] = t142;
    $[222] = t143;
  } else {
    t143 = $[222];
  }
  let t144;
  if ($[223] !== t143) {
    t144 = <td className="tw-text-right !tw-text-[#fff]">{t143}</td>;
    $[223] = t143;
    $[224] = t144;
  } else {
    t144 = $[224];
  }
  const t145 = activity?.sales_count_memes;
  let t146;
  if ($[225] !== t145) {
    t146 = numberWithCommas(t145);
    $[225] = t145;
    $[226] = t146;
  } else {
    t146 = $[226];
  }
  let t147;
  if ($[227] !== t146) {
    t147 = <td className="tw-text-right !tw-text-[#fff]">{t146}</td>;
    $[227] = t146;
    $[228] = t147;
  } else {
    t147 = $[228];
  }
  const t148 = activity?.sales_count_nextgen;
  let t149;
  if ($[229] !== t148) {
    t149 = numberWithCommas(t148);
    $[229] = t148;
    $[230] = t149;
  } else {
    t149 = $[230];
  }
  let t150;
  if ($[231] !== t149) {
    t150 = <td className="tw-text-right !tw-text-[#fff]">{t149}</td>;
    $[231] = t149;
    $[232] = t150;
  } else {
    t150 = $[232];
  }
  const t151 = activity?.sales_count_gradients;
  let t152;
  if ($[233] !== t151) {
    t152 = numberWithCommas(t151);
    $[233] = t151;
    $[234] = t152;
  } else {
    t152 = $[234];
  }
  let t153;
  if ($[235] !== t152) {
    t153 = <td className="tw-text-right !tw-text-[#fff]">{t152}</td>;
    $[235] = t152;
    $[236] = t153;
  } else {
    t153 = $[236];
  }
  const t154 = activity?.sales_count_memelab;
  let t155;
  if ($[237] !== t154) {
    t155 = numberWithCommas(t154);
    $[237] = t154;
    $[238] = t155;
  } else {
    t155 = $[238];
  }
  let t156;
  if ($[239] !== t155) {
    t156 = <td className="tw-text-right !tw-text-[#fff]">{t155}</td>;
    $[239] = t155;
    $[240] = t156;
  } else {
    t156 = $[240];
  }
  let t157;
  if ($[241] !== t144 || $[242] !== t147 || $[243] !== t150 || $[244] !== t153 || $[245] !== t156) {
    t157 = <tr>{t141}{t144}{t147}{t150}{t153}{t156}</tr>;
    $[241] = t144;
    $[242] = t147;
    $[243] = t150;
    $[244] = t153;
    $[245] = t156;
    $[246] = t157;
  } else {
    t157 = $[246];
  }
  let t158;
  if ($[247] === Symbol.for("react.memo_cache_sentinel")) {
    t158 = <td className="!tw-text-[#93939f]"><b>Sales (ETH)</b></td>;
    $[247] = t158;
  } else {
    t158 = $[247];
  }
  const t159 = activity?.sales_value;
  let t160;
  if ($[248] !== t159) {
    t160 = printEthValue(t159);
    $[248] = t159;
    $[249] = t160;
  } else {
    t160 = $[249];
  }
  let t161;
  if ($[250] !== t160) {
    t161 = <td className="tw-text-right !tw-text-[#fff]">{t160}</td>;
    $[250] = t160;
    $[251] = t161;
  } else {
    t161 = $[251];
  }
  const t162 = activity?.sales_value_memes;
  let t163;
  if ($[252] !== t162) {
    t163 = printEthValue(t162);
    $[252] = t162;
    $[253] = t163;
  } else {
    t163 = $[253];
  }
  let t164;
  if ($[254] !== t163) {
    t164 = <td className="tw-text-right !tw-text-[#fff]">{t163}</td>;
    $[254] = t163;
    $[255] = t164;
  } else {
    t164 = $[255];
  }
  const t165 = activity?.sales_value_nextgen;
  let t166;
  if ($[256] !== t165) {
    t166 = printEthValue(t165);
    $[256] = t165;
    $[257] = t166;
  } else {
    t166 = $[257];
  }
  let t167;
  if ($[258] !== t166) {
    t167 = <td className="tw-text-right !tw-text-[#fff]">{t166}</td>;
    $[258] = t166;
    $[259] = t167;
  } else {
    t167 = $[259];
  }
  const t168 = activity?.sales_value_gradients;
  let t169;
  if ($[260] !== t168) {
    t169 = printEthValue(t168);
    $[260] = t168;
    $[261] = t169;
  } else {
    t169 = $[261];
  }
  let t170;
  if ($[262] !== t169) {
    t170 = <td className="tw-text-right !tw-text-[#fff]">{t169}</td>;
    $[262] = t169;
    $[263] = t170;
  } else {
    t170 = $[263];
  }
  const t171 = activity?.sales_value_memelab;
  let t172;
  if ($[264] !== t171) {
    t172 = printEthValue(t171);
    $[264] = t171;
    $[265] = t172;
  } else {
    t172 = $[265];
  }
  let t173;
  if ($[266] !== t172) {
    t173 = <td className="tw-text-right !tw-text-[#fff]">{t172}</td>;
    $[266] = t172;
    $[267] = t173;
  } else {
    t173 = $[267];
  }
  let t174;
  if ($[268] !== t161 || $[269] !== t164 || $[270] !== t167 || $[271] !== t170 || $[272] !== t173) {
    t174 = <tr>{t158}{t161}{t164}{t167}{t170}{t173}</tr>;
    $[268] = t161;
    $[269] = t164;
    $[270] = t167;
    $[271] = t170;
    $[272] = t173;
    $[273] = t174;
  } else {
    t174 = $[273];
  }
  let t175;
  if ($[274] !== t105 || $[275] !== t123 || $[276] !== t140 || $[277] !== t157 || $[278] !== t174 || $[279] !== t20 || $[280] !== t37 || $[281] !== t54 || $[282] !== t71 || $[283] !== t88) {
    t175 = <Accordion><Accordion.Item defaultChecked={true} eventKey="0">{t1}<Accordion.Body className={styles.collectedAccordionBody}><Container><Row className={`pt-2 pb-2 ${styles.scrollContainer}`}><Col><Table className={styles.collectedAccordionTable}>{t2}<tbody>{t3}{t20}{t37}{t54}{t71}{t88}{t105}{t106}{t123}{t140}{t157}{t174}</tbody></Table></Col></Row></Container></Accordion.Body></Accordion.Item></Accordion>;
    $[274] = t105;
    $[275] = t123;
    $[276] = t140;
    $[277] = t157;
    $[278] = t174;
    $[279] = t20;
    $[280] = t37;
    $[281] = t54;
    $[282] = t71;
    $[283] = t88;
    $[284] = t175;
  } else {
    t175 = $[284];
  }
  return t175;
}
function UserPageStatsActivityOverviewMemes(t0) {
  const $ = _c(5);
  const {
    activity
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Accordion.Button className={styles.collectedAccordionButton}><b>Memes Breakdown By Season</b></Accordion.Button>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== activity) {
    t2 = activity && <Table className={styles.collectedAccordionTable}><thead><tr><th colSpan={1} /><th className="text-right !tw-text-[#93939f]">Transfers In</th><th className="text-right !tw-text-[#93939f]">Airdrops</th><th className="text-right !tw-text-[#93939f]">Mints</th><th className="text-right !tw-text-[#93939f]">Mints (ETH)</th><th className="text-right !tw-text-[#93939f]">Purchases</th><th className="text-right !tw-text-[#93939f]">Purchases (ETH)</th><th className="text-right !tw-text-[#93939f]">Transfers Out</th><th className="text-right !tw-text-[#93939f]">Burns</th><th className="text-right !tw-text-[#93939f]">Sales</th><th className="text-right !tw-text-[#93939f]">Sales (ETH)</th></tr></thead><tbody>{activity.map(_temp)}</tbody></Table>;
    $[1] = activity;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <Accordion><Accordion.Item defaultChecked={true} eventKey="0">{t1}<Accordion.Body className={styles.collectedAccordionBody}><Container><Row className={`pt-2 pb-2 ${styles.scrollContainer}`}><Col>{t2}</Col></Row></Container></Accordion.Body></Accordion.Item></Accordion>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}
function _temp(activity_0) {
  return <Fragment key={`stats-activity-memes-${activity_0.season}`}><UserPageStatsTableHr span={11} /><tr><td className="!tw-text-[#93939f]">Season {activity_0.season}</td><td className="tw-text-right !tw-text-[#fff]">{numberWithCommas(activity_0.transfers_in)}</td><td className="tw-text-right !tw-text-[#fff]">{numberWithCommas(activity_0.airdrops)}</td><td className="tw-text-right !tw-text-[#fff]">{numberWithCommas(activity_0.primary_purchases_count)}</td><td className="tw-text-right !tw-text-[#fff]">{printEthValue(activity_0.primary_purchases_value)}</td><td className="tw-text-right !tw-text-[#fff]">{numberWithCommas(activity_0.secondary_purchases_count)}</td><td className="tw-text-right !tw-text-[#fff]">{printEthValue(activity_0.secondary_purchases_value)}</td><td className="tw-text-right !tw-text-[#fff]">{numberWithCommas(activity_0.transfers_out)}</td><td className="tw-text-right !tw-text-[#fff]">{numberWithCommas(activity_0.burns)}</td><td className="tw-text-right !tw-text-[#fff]">{numberWithCommas(activity_0.sales_count)}</td><td className="tw-text-right !tw-text-[#fff]">{printEthValue(activity_0.sales_value)}</td></tr></Fragment>;
}